var map = {
	"./circle/abkhazia.svg": "6706",
	"./circle/afghanistan.svg": "228a",
	"./circle/aland-islands.svg": "e5fe",
	"./circle/albania.svg": "c06c",
	"./circle/algeria.svg": "9678",
	"./circle/american-samoa.svg": "3cf7",
	"./circle/andorra.svg": "1811",
	"./circle/angola.svg": "c5a7",
	"./circle/anguilla.svg": "d112",
	"./circle/antigua-and-barbuda.svg": "05e3",
	"./circle/argentina.svg": "0db8",
	"./circle/armenia.svg": "b7b4",
	"./circle/aruba.svg": "5e10",
	"./circle/australia.svg": "124f",
	"./circle/austria.svg": "89a5",
	"./circle/azerbaijan.svg": "cc24",
	"./circle/azores-islands.svg": "cc01",
	"./circle/baac.svg": "75583",
	"./circle/bahamas.svg": "30ab",
	"./circle/bahrain.svg": "52c3",
	"./circle/balearic-islands.svg": "2c3e",
	"./circle/bangladesh.svg": "7529",
	"./circle/barbados.svg": "441f",
	"./circle/basque-country.svg": "626a",
	"./circle/belarus.svg": "51ea",
	"./circle/belgium.svg": "43e9",
	"./circle/belize.svg": "2ebe",
	"./circle/benin.svg": "504b",
	"./circle/bermuda.svg": "e0b2",
	"./circle/bhutan-1.svg": "0688",
	"./circle/bhutan.svg": "49f2",
	"./circle/bolivia.svg": "d7e0",
	"./circle/bonaire.svg": "77f9",
	"./circle/bosnia-and-herzegovina.svg": "ab3f",
	"./circle/botswana.svg": "0719",
	"./circle/brazil.svg": "f26d",
	"./circle/british-columbia.svg": "c627",
	"./circle/british-indian-ocean-territory.svg": "5b57",
	"./circle/british-virgin-islands.svg": "2aeb",
	"./circle/brunei.svg": "7a12",
	"./circle/bulgaria.svg": "c5cd",
	"./circle/burkina-faso.svg": "47ef",
	"./circle/burundi.svg": "c726",
	"./circle/cambodia.svg": "19f1",
	"./circle/cameroon.svg": "44a4",
	"./circle/canada.svg": "7f98",
	"./circle/canary-islands.svg": "8532",
	"./circle/cape-verde.svg": "b0c42",
	"./circle/cayman-islands.svg": "1dcb",
	"./circle/central-african-republic.svg": "03e6",
	"./circle/ceuta.svg": "2697",
	"./circle/chad.svg": "d549",
	"./circle/chile.svg": "3f6f",
	"./circle/china.svg": "4bcf",
	"./circle/christmas-island.svg": "63ef",
	"./circle/cocos-island.svg": "f94e",
	"./circle/colombia.svg": "1e56",
	"./circle/comoros.svg": "4b14",
	"./circle/cook-islands.svg": "d902",
	"./circle/corsica.svg": "42c4",
	"./circle/costa-rica.svg": "6fd9",
	"./circle/croatia.svg": "586e",
	"./circle/cuba.svg": "db58",
	"./circle/curacao.svg": "1bead",
	"./circle/cyprus.svg": "d2ac5",
	"./circle/czech-republic.svg": "ddfb",
	"./circle/democratic-republic-of-congo.svg": "af4b",
	"./circle/denmark.svg": "238c",
	"./circle/djibouti.svg": "1874",
	"./circle/dominica.svg": "9731",
	"./circle/dominican-republic.svg": "bae0",
	"./circle/east-timor.svg": "5285",
	"./circle/ecuador.svg": "ac7a",
	"./circle/egypt.svg": "33da",
	"./circle/england.svg": "bbd8",
	"./circle/equatorial-guinea.svg": "1f60",
	"./circle/eritrea.svg": "79b4",
	"./circle/estonia.svg": "7c46",
	"./circle/ethiopia.svg": "591e",
	"./circle/european-union.svg": "86a3",
	"./circle/falkland-islands.svg": "2820",
	"./circle/faroe-islands.svg": "12c3",
	"./circle/fiji.svg": "72c1",
	"./circle/finland.svg": "c0e1",
	"./circle/france.svg": "1ba4",
	"./circle/french-polynesia.svg": "4246",
	"./circle/gabon.svg": "65ce",
	"./circle/galapagos-islands.svg": "a55d",
	"./circle/gambia.svg": "0f70",
	"./circle/georgia.svg": "a794",
	"./circle/germany.svg": "8b11",
	"./circle/ghana.svg": "eecd",
	"./circle/gibraltar.svg": "6086",
	"./circle/greece.svg": "a14f",
	"./circle/greenland.svg": "537c",
	"./circle/grenada.svg": "90ce",
	"./circle/gsb.svg": "92ad",
	"./circle/guam.svg": "6e26",
	"./circle/guatemala.svg": "4e98",
	"./circle/guernsey.svg": "24ab",
	"./circle/guinea-bissau.svg": "eb78",
	"./circle/guinea.svg": "0220",
	"./circle/guyana.svg": "01a1",
	"./circle/haiti.svg": "2da2",
	"./circle/hawaii.svg": "bc25",
	"./circle/honduras.svg": "6829",
	"./circle/hong-kong.svg": "cfab",
	"./circle/hungary.svg": "a4fe",
	"./circle/iceland.svg": "4510",
	"./circle/india.svg": "acf6",
	"./circle/indonesia.svg": "f992",
	"./circle/iran.svg": "af98",
	"./circle/iraq.svg": "1d11",
	"./circle/ireland.svg": "696f",
	"./circle/isle-of-man.svg": "4660",
	"./circle/israel.svg": "0732",
	"./circle/italy.svg": "a9a0",
	"./circle/ivory-coast.svg": "f2fe",
	"./circle/jamaica.svg": "ac06",
	"./circle/japan.svg": "67e3",
	"./circle/jersey.svg": "319f",
	"./circle/jordan.svg": "c1ea",
	"./circle/kazakhstan.svg": "54db",
	"./circle/kenya.svg": "1dad",
	"./circle/kiribati.svg": "7169",
	"./circle/kosovo.svg": "91d0",
	"./circle/kuwait.svg": "e1cc",
	"./circle/kyrgyzstan.svg": "2667",
	"./circle/laos.svg": "f1ee",
	"./circle/latvia.svg": "4a8d",
	"./circle/lebanon.svg": "13e6",
	"./circle/lesotho.svg": "b494",
	"./circle/liberia.svg": "45b7",
	"./circle/libya.svg": "e747",
	"./circle/liechtenstein.svg": "44d7",
	"./circle/lithuania.svg": "e29b",
	"./circle/luxembourg.svg": "6c8c",
	"./circle/macao.svg": "5f01",
	"./circle/madagascar.svg": "3c95",
	"./circle/madeira.svg": "d130",
	"./circle/malawi.svg": "6a14",
	"./circle/malaysia.svg": "076a",
	"./circle/maldives.svg": "c660",
	"./circle/mali.svg": "1d7f",
	"./circle/malta.svg": "c9d0",
	"./circle/marshall-island.svg": "2f46",
	"./circle/martinique.svg": "3b85",
	"./circle/mauritania.svg": "185d",
	"./circle/mauritius.svg": "0b8f",
	"./circle/melilla.svg": "b6df",
	"./circle/mexico.svg": "a5ca",
	"./circle/micronesia.svg": "ab34",
	"./circle/moldova.svg": "14d3",
	"./circle/monaco.svg": "2aa9",
	"./circle/mongolia.svg": "97de",
	"./circle/montenegro.svg": "a121",
	"./circle/montserrat.svg": "b4ec",
	"./circle/morocco.svg": "8c0c",
	"./circle/mozambique.svg": "98c8",
	"./circle/myanmar.svg": "b994",
	"./circle/namibia.svg": "367c",
	"./circle/nato.svg": "173b",
	"./circle/nauru.svg": "b741",
	"./circle/nepal.svg": "79dc",
	"./circle/netherlands.svg": "7aeb",
	"./circle/new-zealand.svg": "7a487",
	"./circle/nicaragua.svg": "9ec9",
	"./circle/niger.svg": "8aa0",
	"./circle/nigeria.svg": "2b39",
	"./circle/niue.svg": "2fab",
	"./circle/norfolk-island.svg": "39ac",
	"./circle/north-korea.svg": "bcd8",
	"./circle/northen-cyprus.svg": "66a9",
	"./circle/northern-marianas-islands.svg": "8d62",
	"./circle/norway.svg": "8165",
	"./circle/oman.svg": "4fd0",
	"./circle/orkney-islands.svg": "fc94",
	"./circle/ossetia.svg": "acaa",
	"./circle/pakistan.svg": "d857",
	"./circle/palau.svg": "15d5",
	"./circle/palestine.svg": "6bae",
	"./circle/panama.svg": "d552",
	"./circle/papua-new-guinea.svg": "1f7a",
	"./circle/paraguay.svg": "d29b",
	"./circle/peru.svg": "2dcd",
	"./circle/philippines.svg": "f1af",
	"./circle/pitcairn-islands.svg": "ea4d",
	"./circle/portugal.svg": "5db5",
	"./circle/puerto-rico.svg": "ea52",
	"./circle/qatar.svg": "1898",
	"./circle/rapa-nui.svg": "59fc",
	"./circle/republic-of-macedonia.svg": "7993",
	"./circle/republic-of-poland.svg": "a07a",
	"./circle/republic-of-the-congo.svg": "c20c",
	"./circle/romania.svg": "46af",
	"./circle/russia.svg": "363c",
	"./circle/rwanda.svg": "5abe",
	"./circle/saba-island.svg": "8013",
	"./circle/saint-kitts-and-nevis.svg": "1e1d",
	"./circle/salvador.svg": "c614",
	"./circle/samoa.svg": "c31a",
	"./circle/san-marino.svg": "addb",
	"./circle/sao-tome-and-principe.svg": "47db",
	"./circle/sardinia.svg": "8358",
	"./circle/saudi-arabia.svg": "4f39",
	"./circle/scotland.svg": "5d54",
	"./circle/senegal.svg": "a14b",
	"./circle/serbia.svg": "6dd2",
	"./circle/seychelles.svg": "4309",
	"./circle/sierra-leone.svg": "d621",
	"./circle/singapore.svg": "0a49",
	"./circle/sint-eustatius.svg": "ea11",
	"./circle/sint-maarten.svg": "229b",
	"./circle/slovakia.svg": "2bde",
	"./circle/slovenia.svg": "b423",
	"./circle/solomon-islands.svg": "c966",
	"./circle/somalia.svg": "58e9",
	"./circle/somaliland.svg": "c9f0",
	"./circle/south-africa.svg": "c835",
	"./circle/south-korea.svg": "b99a",
	"./circle/south-sudan.svg": "648f",
	"./circle/spain.svg": "d504",
	"./circle/sri-lanka.svg": "64179",
	"./circle/st-barts.svg": "0fe9",
	"./circle/st-lucia.svg": "d3bd",
	"./circle/st-vincent-and-the-grenadines.svg": "d088",
	"./circle/sudan.svg": "ec14",
	"./circle/suriname.svg": "9637",
	"./circle/swaziland.svg": "189f",
	"./circle/sweden.svg": "6ec4",
	"./circle/switzerland.svg": "fcf7",
	"./circle/syria.svg": "3ce7",
	"./circle/taiwan.svg": "f303",
	"./circle/tajikistan.svg": "f513",
	"./circle/tanzania.svg": "58bd",
	"./circle/thailand.svg": "0812",
	"./circle/tibet.svg": "a101",
	"./circle/togo.svg": "a03d",
	"./circle/tokelau.svg": "f0f8",
	"./circle/tonga.svg": "7696",
	"./circle/transnistria.svg": "a18d",
	"./circle/trinidad-and-tobago.svg": "81d5",
	"./circle/tunisia.svg": "8644",
	"./circle/turkey.svg": "6494",
	"./circle/turkmenistan.svg": "6cb9",
	"./circle/turks-and-caicos.svg": "efbd",
	"./circle/tuvalu.svg": "0606",
	"./circle/uganda.svg": "d47e",
	"./circle/ukraine.svg": "dc7d",
	"./circle/united-arab-emirates.svg": "0abb",
	"./circle/united-kingdom.svg": "eee3",
	"./circle/united-nations.svg": "ab6e",
	"./circle/united-states-of-america.svg": "cf06",
	"./circle/uruguay.svg": "6dac",
	"./circle/uzbekistn.svg": "1e9d",
	"./circle/vanuatu.svg": "3f9d",
	"./circle/vatican-city.svg": "034d",
	"./circle/venezuela.svg": "7d5e",
	"./circle/vietnam.svg": "679d",
	"./circle/virgin-islands.svg": "4bee",
	"./circle/wales.svg": "88ac",
	"./circle/western-sahara.svg": "59a8",
	"./circle/yemen.svg": "1993",
	"./circle/zambia.svg": "309f",
	"./circle/zimbabwe.svg": "ebca",
	"./cn.svg": "8f59",
	"./de.svg": "eca6",
	"./eg.svg": "70e2",
	"./gb.svg": "ea15",
	"./govement/calculator.png": "1c82",
	"./govement/clipart.png": "9fb5",
	"./govement/huayrat_2.png": "ccae",
	"./govement/huayrat_small.png": "3636",
	"./govement/huayrat_small_2.png": "dba6",
	"./govement/lottery-icon-pur2.png": "63da",
	"./govement/lottery-icon-pur_b.png": "a83c",
	"./govement/lottery-icon2.png": "24f7",
	"./govement/lottery-icon_b.png": "de44",
	"./hk.svg": "7689",
	"./in.svg": "a0c6",
	"./jp.svg": "6c59",
	"./kr.svg": "b9f9",
	"./la.svg": "032d",
	"./my.svg": "a67f",
	"./ru.svg": "a0fd",
	"./sg.svg": "16c6",
	"./th.svg": "7776",
	"./tw.svg": "8c6d",
	"./us.svg": "b38c",
	"./vn.svg": "71d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "757f";